export const SERVICE_FETCH = {
  endpoint: '/availability',
  method: 'get',
  hostel: true,
};
